import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useMe } from '@/api/queries/auth';
import { Spinner } from '@/components/Spinner';

/**
 * Guarda as telas de administração. Vai dentro da `ProtectedRoute` (que já garante o
 * login), então aqui só resta a checagem de papel.
 *
 * <p>Sem isso, o menu escondia o link mas a URL direta — favorito, aba antiga, link
 * colado — levava qualquer pessoa logada à tela de Administração, que disparava duas
 * chamadas de admin e devolvia dois avisos vermelhos de acesso negado. Quem não é
 * administrador volta para a lista de processos, sem erro na cara.
 */
export function AdminRoute({ children }: { children: ReactNode }) {
  const me = useMe();

  if (me.isLoading) {
    return (
      <main className="flex min-h-screen items-center justify-center p-4">
        <Spinner />
      </main>
    );
  }

  if (me.data?.admin !== true) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
